import React, { useEffect, useState } from 'react';
import { Button, Toast } from 'antd-mobile';
import { Modal, Space, Table, Typography, Card } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { set } from 'date-fns';
import secureStorage from 'shared/secureStorage';

const { Column, ColumnGroup } = Table;
const { Link } = Typography;
const webviewHttpHandler = new WebviewHttpHandler(true);

const brandPreferenceValueMap = [
  'TOYOTA',
  'LEXUS',
  'TESLA',
  'BENZ,BMW',
  'VOLVO',
  '其他',
];

const RecommendProject = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState('');
  var brandPreference = '';
  // 將品牌偏好轉換成字串
  const reformatBrandPreference = (brandPreference) => {
    console.log(brandPreference, brandPreferenceValueMap);
    var brandString = '';
    for (let i = 0; i < brandPreference.length; i++) {
      if (brandPreference[i] === '1') {
        brandString += brandPreferenceValueMap[i] + ',';
      }
    }
    if (brandString.endsWith(',')) {
      brandString = brandString.slice(0, -1);
    }
    return brandString;
  };
  // 客戶填問卷時對長租有興趣, 就會取得品牌偏好, 若是業代進來則沒有品牌偏好
  if (location.state && location.state.brandPreference) {
    brandPreference = reformatBrandPreference(location.state.brandPreference);
  }
  // 取得推薦專案
  const getRecommendProject = () => {
    if (brandPreference) {
      var url =
        '/line-official-mgmt/project/list/external?brand_preference=' +
        brandPreference;
    } else {
      var url = '/line-official-mgmt/project/list/external';
    }
    webviewHttpHandler.get(url).then((response) => {
      if (response.success) {
        setProjectList(response.data);
        setLoading(false);
      } else {
        console.error('取得推薦專案失敗');
      }
    });
  };
  // 分享到Line
  const handleShareMsg = (content) => () => {
    webviewHttpHandler.post(
      `/chatbot_mgmt/push_message?user_id=${secureStorage.getItem(
        'lineUserId'
      )}&content=${content}`
    );
  };
  // 檢視內容
  const viewContent = (title, content) => () => {
    setModalOpen(true);
    setModalTitle(title);
    setModalContent(content);
  };

  useEffect(() => {
    getRecommendProject();
  }, []);

  return (
    <>
      <div className="main-container">
        <div className="form-container">
          <div className="heading-s font-bold">推薦專案</div>
          <p className="text-body font-normal">
            依據您的用車習慣推薦以下專案，如有興趣可點選專案右方按鈕，系統將推送專案介紹至您的訊息中。
          </p>
          <Table
            rowKey={(row) => row.id}
            className="project-table"
            dataSource={projectList}
            pagination={false}
            loading={loading}>
            <Column
              title="專案"
              dataIndex="name"
              width={'55%'}
              render={(text, record) => (
                <Link href={record.url} target="_blank">
                  {text}
                </Link> // 使用Link组件添加可点击的链接
              )}
            />
            <Column
              title="內容"
              key="action"
              render={(_, record) => (
                <Space size="middle">
                  <Button
                    className="send-to-line-button"
                    // onClick={handleShareMsg(record.content)}
                    onClick={viewContent(record.name, record.content)}>
                    檢視內容
                  </Button>
                </Space>
              )}
            />
          </Table>
          <Modal
            open={modalOpen}
            title={modalTitle}
            onCancel={() => setModalOpen(false)}
            footer={null}>
            <Card style={{ overflowY: 'auto', whiteSpace: 'pre-line' }}>
              {modalContent}
            </Card>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default RecommendProject;
